import { createColumnConfigStore } from './column-config-store';

const SEQUENCE_DEFAULT_COLUMNS = ['sent', 'openRate', 'clickRate', 'replyRate'];

export const useSequenceColumnConfigStore = createColumnConfigStore(
  'sequence-v2',
  SEQUENCE_DEFAULT_COLUMNS,
);
